import type { FC } from 'react';

import { useTranslation } from 'next-i18next/pages';

import { Button } from 'antd';

import { AnswerQuestionSection } from '@/components/AboutUsContainer/AnswerQuestionSection/AnswerQuestionSection';
import { Tariffs } from '@/components/MainLanding';
import { TranslationNamespace } from '@/i18n';

import { CalcIntro } from '../CalcIntro/CalcIntro';
import { DelegationSection } from '../DelegationSection/DelegationSection';
import { PlatformInfo } from '../PlatformInfo/PlatformInfo';

import { calcAnswerAndQuestions } from './CalcContent.utils';

import styles from './CalcContent.module.scss';

export const CalcContent: FC = () => {
	const { t } = useTranslation(TranslationNamespace.Calculator);

	return (
		<>
			<CalcIntro
				title={t('content.title')}
				description={t('content.description')}
				actions={
					<Button
						className={styles.calcButton}
						type="primary"
						href="/calculator"
						target="_blank"
						size="large"
					>
						{t('content.calculate-own')}
					</Button>
				}
				notes={t('content.notes')}
			/>
			<DelegationSection />
			<Tariffs />
			<PlatformInfo />
			<AnswerQuestionSection answerAndQuestions={calcAnswerAndQuestions(t)} />
			<CalcIntro
				title={t('content.title')}
				description={t('content.description')}
				actions={
					<div className={styles.buttons}>
						<Button
							className={styles.calcButton}
							type="primary"
							href="/calculator"
							target="_blank"
							size="large"
						>
							{t('content.calculate-losses')}
						</Button>
						<Button
							className={styles.startButton}
							type="default"
							size="large"
							href="/registration"
							target="_blank"
						>
							{t('content.start-free')}
						</Button>
					</div>
				}
				notes={t('content.notes')}
			/>
		</>
	);
};
